import { render, staticRenderFns } from "./NoteModal.vue?vue&type=template&id=84489518&scoped=true"
import script from "./NoteModal.vue?vue&type=script&lang=ts"
export * from "./NoteModal.vue?vue&type=script&lang=ts"
import style1 from "./NoteModal.vue?vue&type=style&index=1&id=84489518&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84489518",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84489518')) {
      api.createRecord('84489518', component.options)
    } else {
      api.reload('84489518', component.options)
    }
    module.hot.accept("./NoteModal.vue?vue&type=template&id=84489518&scoped=true", function () {
      api.rerender('84489518', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/timesheet/NoteModal.vue"
export default component.exports